import React, { useState, Fragment } from "react";
import * as IoIcons from "react-icons/io";
import "../estilos.css";
import { Row, Label, ModalHeader, ModalBody, ModalFooter, Modal, Button, Input, FormGroup } from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { guardarInspeccion, guardarInspeccionPC } from "../queries/Mutations";

function Inspeccion({
  sProduccion,
  bColor,
  btitle,
  modulo,
  usuario,
  operacion,//scan, individual
  valorDeREtorno,
  proceso,
  racksCarga
}) {


  const [cargando, setCargando] = useState(false);
  const [fecha, setfecha] = useState(new Date());
  const [modalIP, setModalIP] = useState(operacion === "scan" ? true : false);
  const [pInspeccion, setPInspeccion] = useState({
    ...sProduccion, piezasNoAceptadasOriginal: proceso === "PowderCoat" ? sProduccion.piezasNoAceptadasPC : sProduccion.piezasNoAceptadas,
    piezasNoAceptadas: "", piezasEnInspeccionandoRes: sProduccion.piezasDisponibles, numeroRackCarga: sProduccion.ultimoRackPC ? sProduccion.ultimoRackPC :
      sProduccion.ultimoRack ? sProduccion.ultimoRack : "",
    piezasDisponibles: sProduccion.piezasDisponibles, piezasenPintado: proceso === "PowderCoat" ? sProduccion.piezasenPintadoPC :
      sProduccion.piezasenPintado
  });



  async function aceptaInspeccionPP() {
    setCargando(true);
    const result = proceso === "PowderCoat" ? await guardarInspeccionPC(pInspeccion, usuario, modulo) :
      await guardarInspeccion(pInspeccion, usuario, modulo);//"Embarques"
    toggleIP();
    setCargando(false);
    valorDeREtorno(result);
  }
  const toggleIP = () => {
    setModalIP(!modalIP);
    valorDeREtorno({ completo: false });
    delete pInspeccion.pnadefecto;
    delete pInspeccion.pnaotroDefecto;
    //pInspeccion.piezasNoAceptadasOriginal = sProduccion.piezasNoAceptadas;
    pInspeccion.piezasEnInspeccionando = sProduccion.piezasDisponibles;
    pInspeccion.piezasEnInspeccionandoRes = sProduccion.piezasDisponibles;
    pInspeccion.piezasDisponibles = sProduccion.piezasDisponibles;
    pInspeccion.piezasenPintado = proceso === "PowderCoat" ? sProduccion.piezasenPintadoPC : sProduccion.piezasenPintado;
    delete pInspeccion.piezasNoAceptadas;
  };

  function onChangesCantidadIP(e) {
    e.persist()
    const re = /^[0-9\.]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      if (e.target.name === "piezasNoAceptadas") {
        const restaInspecc = (parseInt(pInspeccion.piezasDisponibles ? pInspeccion.piezasDisponibles : 0) -
          parseInt(e.target.value === "" ? 0 : e.target.value));
        setPInspeccion(() => ({
          ...pInspeccion, [e.target.name]: e.target.value,
          "piezasEnInspeccionandoRes": restaInspecc > 0 ? restaInspecc : 0,
          "piezasEnInspeccionando": (parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0)
            + parseInt(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0)) ===
            parseInt(pInspeccion.piezasDisponibles ? pInspeccion.piezasDisponibles : 0) ? restaInspecc > 0 ? restaInspecc : 0 :
            parseInt(pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : 0)
        }));
      } else {
        setPInspeccion(() => ({
          ...pInspeccion, [e.target.name]: e.target.value
        }));
      }
    }
  }

  function onChangesIP(e) {
    e.persist()
    setPInspeccion(() => ({
      ...pInspeccion, [e.target.name]: e.target.value
    }));
  }

  /*function clicInspeccion(lista) {
    delete lista.pnadefecto;
    delete lista.pnaotroDefecto;
    toggleIP();
  };*/

  return (
    <>
      {cargando === true && (
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
          <img width="150px" src="assets/img/preloader.gif" />
        </div>
      )}
      {cargando === false && (
        <button
          class={"btn-" + bColor + " cbutton"}
          title={btitle}
          onClick={() => toggleIP()}
        >
          <IoIcons.IoMdSearch />
        </button>
      )}

      <Modal isOpen={modalIP} size="lg" toggle={toggleIP} >
        <ModalHeader toggle={toggleIP} >Inspección del material</ModalHeader>
        <ModalBody>
          {cargando === true && (
            <Row>
              <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 textaligmentcenter"></div>
              <p className="ml-2">Guardando datos, espere un momento por favor.</p>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 textaligmentcenter ">
                <img class="floatcenter" width="150px" src="assets/img/preloader.gif" />
              </div>
            </Row>

          )}
          {cargando === false && (
            <Fragment>
              <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                <Table className=" mb-2 scroll " >
                  <Thead class="thead-secondary">
                    <Tr>
                      <Th className="minwidth100px">Cliente</Th>
                      <Th >Número de parte</Th>
                      <Th >Descripción</Th>
                      <Th>Serial</Th>
                      <Th className="minwidth100px">Serial BTI</Th>
                      <Th className="minwidth60p ">Piezas pintadas</Th>
                      {/*<Th className="minwidth60p ">Piezas disponibles</Th>*/}
                      <Th className="minwidth60p ">Piezas aceptadas</Th>
                      <Th className="minwidth60p ">Piezas no aceptadas</Th>
                      {/*<Th className="minwidth60p ">Piezas en recuperación</Th>*/}
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr >
                      <Td>{pInspeccion.cliente}</Td>
                      <Td>{pInspeccion.numerodeParte}</Td>
                      <Td >{pInspeccion.descripcion}</Td>
                      <Td className={pInspeccion.descripcion ? "" : "margintopmobil20px"}>{pInspeccion.serial}</Td>
                      <Td >{pInspeccion.serialRecibaBTI}</Td>
                      <Td>{proceso === "PowderCoat" ? (pInspeccion.piezasenPintadoPC > 0 ?
                        pInspeccion.piezasenPintadoPC : "") : (pInspeccion.piezasenPintado > 0 ?
                          pInspeccion.piezasenPintado : "")}</Td>
                      {/*<Td>{pInspeccion.piezasEnInspeccionandoRes > 0 ? pInspeccion.piezasEnInspeccionandoRes : ""}</Td>*/}
                      <Td className=" ">{proceso === "PowderCoat" ? (pInspeccion.piezasCalidadPC > 0 ? pInspeccion.piezasCalidadPC : "") :
                        (pInspeccion.piezasCalidad > 0 ? pInspeccion.piezasCalidad : "")}</Td>
                      <Td className={pInspeccion.piezasCalidad ? "marginbottommobil20px" : "margintopmobil20px marginbottommobil20px"}>
                        {pInspeccion.piezasNoAceptadasOriginal > 0 ? pInspeccion.piezasNoAceptadasOriginal : ""}
                      </Td>
                      {/*} <Td >{pInspeccion.piezasIRecuperacion > 0 ? "Inspeción: " + pInspeccion.piezasIRecuperacion : ""}
                        {pInspeccion.piezasCRecuperacion > 0 ? "Calidad: " + pInspeccion.piezasCRecuperacion : ""}</Td>*/}
                    </Tr>
                  </Tbody>
                </Table>
              </div>
              <Row >
                {/*<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 margintop20px">
                 JSON.stringify(pInspeccion)
                </div>*/}

                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 margintop20px">
                  <Label className={(pInspeccion.piezasEnInspeccionando > pInspeccion.piezasDisponibles ||
                    pInspeccion.piezasEnInspeccionando < 0) ? "fcolorred floatleft" : "floatleft"} >Piezas aceptables  </Label>
                  <Label className="floatleft fontbluekbold ml-1" >{pInspeccion.piezasEnInspeccionandoRes ? pInspeccion.piezasEnInspeccionandoRes : 0} </Label>
                  <Label className="floatleft fontbluekbold " > *</Label>
                  <Label className="floatleft " > :</Label>
                  <Input name="piezasEnInspeccionando" value={pInspeccion.piezasEnInspeccionando ? pInspeccion.piezasEnInspeccionando : ""} onChange={e => onChangesCantidadIP(e)} />
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 margintop20px">
                  <FormGroup>
                    <Label className={(pInspeccion.piezasNoAceptadas ? pInspeccion.piezasNoAceptadas : 0) >
                      (pInspeccion.piezasDisponibles ? pInspeccion.piezasDisponibles : 0) ? "fcolorred floatleft" : "floatleft"} >Piezas no aceptables: {/*pInspeccion.piezasNoAceptadas*/}</Label>
                    <Input name="piezasNoAceptadas" value={pInspeccion.piezasNoAceptadas} onChange={e => onChangesCantidadIP(e)} />
                  </FormGroup>
                </div>
                {<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 margintop20px">
                  <FormGroup >
                    <Label className={"floatleft margintop-30px"} >Número de Rack:  </Label>
                    <div className={"select-editable  margintop30px"}>
                      <select
                        name="numeroRackCarga  "
                        className="floatleft  custom-select "
                        onChange={e => onChangesIP(e)}
                      >
                        {racksCarga.map((rack, i) => (
                          rack.serialRecibaBTI === pInspeccion.serialRecibaBTI && (
                            <>
                              <option
                                className=""
                                value={rack.rack}
                                selected={pInspeccion.numeroRackCarga === rack.rack ? true : false}
                              >
                                {rack.rack}
                              </option>
                            </>)
                        ))}
                      </select>
                      <input
                        className=""
                        name="numeroRackCarga"
                        maxLength={20}
                        type="text"
                        value={pInspeccion.numeroRackCarga}
                        onChange={e => onChangesIP(e)}
                      />
                    </div>
                  </FormGroup>
                </div>}
              </Row>

              {pInspeccion.piezasNoAceptadas && (
                <>
                  <Row >
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <FormGroup>
                        <Label className="floatleft ">Defecto*:</Label>
                        <select name="pnadefecto" className=" custom-select" onChange={e => onChangesIP(e)}  >
                          <option value="" selected={pInspeccion.pnadefecto == "" ? true : false}>Elije una opción</option>
                          <option value="Reyadura/Golpe" selected={pInspeccion.pnadefecto == "Reyadura/Golpe" ? true : false}>Reyadura/Golpe</option>
                          <option value="Grumo/Impureza" selected={pInspeccion.pnadefecto == "Grumo/Impureza" ? true : false}>Grumo/Impureza</option>
                          <option value="Falta escurriemiento" selected={pInspeccion.pnadefecto == "Falta escurriemiento" ? true : false}>Falta escurriemiento</option>
                          <option value="Falso contacto" selected={pInspeccion.pnadefecto == "Falso contacto" ? true : false}>Falso contacto</option>
                          <option value="Pin hole" selected={pInspeccion.pnadefecto == "Pin hole" ? true : false}>Pin hole</option>
                          <option value="Contaminacion" selected={pInspeccion.pnadefecto == "Contaminacion" ? true : false}>Contaminacion</option>
                          <option value="Burbuja" selected={pInspeccion.pnadefecto == "Burbuja" ? true : false}>Burbuja</option>
                          <option value="Falta pintura" selected={pInspeccion.pnadefecto == "Falta pintura" ? true : false}>Falta pintura</option>
                          <option value="Oxido" selected={pInspeccion.pnadefecto == "Oxido" ? true : false}>Oxido</option>
                          <option value="Dobles" selected={pInspeccion.pnadefecto == "Dobles" ? true : false}>Dobles</option>
                          <option value="Cenizo" selected={pInspeccion.pnadefecto == "Cenizo" ? true : false}>Cenizo</option>
                          <option value="Otro" selected={pInspeccion.pnadefecto == "Otro" ? true : false}>Otro</option>
                        </select>
                      </FormGroup>
                    </div>
                    {pInspeccion.pnadefecto === "Otro" && (
                      <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                        <Label className="floatleft" >Otro defecto*: </Label>
                        <Input name="pnaotroDefecto" onChange={e => onChangesIP(e)} />
                      </div>
                    )}
                  </Row>
                </>
              )}
              {/*pInspeccion.piezasEnRecuperando && (
                <>
                  <Row >
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <FormGroup>
                        <Label className="floatleft ">Defecto*:</Label>
                        <select name="defecto" className=" custom-select" onChange={e => onChangesIP(e)}  >
                          <option value="" selected={pInspeccion.defecto == "" ? true : false}>Elije una opción</option>
                          <option value="Reyadura/Golpe" selected={pInspeccion.defecto == "Reyadura/Golpe" ? true : false}>Reyadura/Golpe</option>
                          <option value="Grumo/Impureza" selected={pInspeccion.defecto == "Grumo/Impureza" ? true : false}>Grumo/Impureza</option>
                          <option value="Falta escurriemiento" selected={pInspeccion.defecto == "Falta escurriemiento" ? true : false}>Falta escurriemiento</option>
                          <option value="Falso contacto" selected={pInspeccion.defecto == "Falso contacto" ? true : false}>Falso contacto</option>
                          <option value="Pin hole" selected={pInspeccion.defecto == "Pin hole" ? true : false}>Pin hole</option>
                          <option value="Contaminacion" selected={pInspeccion.defecto == "Contaminacion" ? true : false}>Contaminacion</option>
                          <option value="Burbuja" selected={pInspeccion.defecto == "Burbuja" ? true : false}>Burbuja</option>
                          <option value="Falta pintura" selected={pInspeccion.defecto == "Falta pintura" ? true : false}>Falta pintura</option>
                          <option value="Oxido" selected={pInspeccion.defecto == "Oxido" ? true : false}>Oxido</option>
                          <option value="Dobles" selected={pInspeccion.defecto == "Dobles" ? true : false}>Dobles</option>
                          <option value="Cenizo" selected={pInspeccion.defecto == "Cenizo" ? true : false}>Cenizo</option>
                          <option value="Otro" selected={pInspeccion.defecto == "Otro" ? true : false}>Otro</option>
                        </select>
                      </FormGroup>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <FormGroup>
                        <Label className="floatleft ">Método de recuperación*:</Label>
                        <select name="mRecuperacion" className=" custom-select" onChange={e => onChangesIP(e)}>
                          <option value="" selected={pInspeccion.defecto == "" ? true : false}>Elije una opción</option>
                          <option value="Spray" selected={pInspeccion.mRecuperacion == "Spray" ? true : false}>Spray</option>
                          <option value="Pistola" selected={pInspeccion.mRecuperacion == "Pistola" ? true : false}>Pistola</option>
                          <option value="Decapado" selected={pInspeccion.mRecuperacion == "Decapado" ? true : false}>Decapado</option>
                          <option value="Desoxidado" selected={pInspeccion.mRecuperacion == "Desoxidado" ? true : false}>Desoxidado</option>
                          <option value="Enderezar  piezas" selected={pInspeccion.mRecuperacion == "Enderezar  piezas" ? true : false}>Enderezar  piezas</option>
                          <option value="Desengrase o limpieza" selected={pInspeccion.mRecuperacion == "Desengrase o limpieza" ? true : false}>Desengrase o limpieza</option>
                          <option value="Otro" selected={pInspeccion.mRecuperacion == "7" ? true : false}>Otro</option>
                        </select>
                      </FormGroup>
                    </div>
                  </Row>
                  <Row>
                    {pInspeccion.defecto === "Otro" && (
                      <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                        <Label className="floatleft" >Otro defecto*: </Label>
                        <Input name="otroDefecto" onChange={e => onChangesIP(e)} />
                      </div>
                    )}
                    {pInspeccion.mRecuperacion === "Otro" && (
                      <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                        <FormGroup>
                          <Label className="floatleft ">Otro método de recuperación*:</Label>
                          <Input name="otroMRecuperacion" onChange={e => onChangesIP(e)} />
                        </FormGroup>
                      </div>

                    )}
                  </Row>
                </>
              )*/}
              <Row>
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <FormGroup>
                    <Label className="floatleft ">Comentarios:</Label>
                    <Input type="textarea" rows="2" name="comentariosInspeccion" onChange={e => onChangesIP(e)} />
                  </FormGroup>
                </div>
              </Row>
              <Row>
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Label className="floatleft fontblue10px" >*Número máximo de piezas aceptables </Label>
                </div>
              </Row>
            </Fragment>
          )}
        </ModalBody>
        <ModalFooter>
          {cargando === false && (
            <Fragment>
              {/*pInspeccion.piezasEnRecuperando*/}
              <Button color="primary" disabled={(pInspeccion.piezasEnInspeccionando < 0) ||
                (pInspeccion.piezasEnInspeccionando > pInspeccion.piezasDisponibles) ||
                (pInspeccion.piezasNoAceptadas > pInspeccion.piezasDisponibles) ||
                (!pInspeccion.piezasNoAceptadas && !pInspeccion.piezasEnInspeccionando)} onClick={aceptaInspeccionPP}>Aceptar</Button>{' '}
              <Button color="danger" onClick={toggleIP}>Cancelar</Button>
            </Fragment>
          )}
        </ModalFooter>
      </Modal>
    </>
  );
}
export default Inspeccion;
